import { EApiLanguageCode, EApiAttendanceType } from '@datatype/iyagigo/api-type';

export const getHasDateAttendance = (attendances: { attendedAt: string }[], targetDate: Date) => {
  return attendances.some((attendance) => {
    const attendedDate = new Date(attendance.attendedAt);
    return attendedDate.toDateString() === targetDate.toDateString();
  });
};

// mainMenu가 필요한 이유: subMenu 'grammar'가 cloze(빈칸문제)와 classroom(일본어교실) 양쪽에
// 존재해 subMenu만으로는 구분되지 않는다.
export const getAttendanceType = (
  studyLanguage: EApiLanguageCode | null,
  subMenu: string | null,
  mainMenu?: string | null,
): EApiAttendanceType => {
  const isEnglish = studyLanguage === EApiLanguageCode.ENGLISH;
  if (mainMenu === 'classroom') {
    if (subMenu === 'character') {
      return isEnglish
        ? EApiAttendanceType.ENGLISH_CLASSROOM_CHARACTER
        : EApiAttendanceType.JAPANESE_CLASSROOM_CHARACTER;
    }
    if (subMenu === 'grammar') {
      return isEnglish ? EApiAttendanceType.ENGLISH_CLASSROOM_GRAMMAR : EApiAttendanceType.JAPANESE_CLASSROOM_GRAMMAR;
    }
    if (subMenu === 'expression') {
      return isEnglish
        ? EApiAttendanceType.ENGLISH_CLASSROOM_EXPRESSION
        : EApiAttendanceType.JAPANESE_CLASSROOM_EXPRESSION;
    }
    if (subMenu === 'conversation') {
      return isEnglish
        ? EApiAttendanceType.ENGLISH_CLASSROOM_CONVERSATION
        : EApiAttendanceType.JAPANESE_CLASSROOM_CONVERSATION;
    }
  }
  if (subMenu === 'authentic-expression') {
    return studyLanguage === EApiLanguageCode.ENGLISH
      ? EApiAttendanceType.ENGLISH_AUTHENTIC_EXPRESSION
      : EApiAttendanceType.JAPANESE_AUTHENTIC_EXPRESSION;
  }
  if (subMenu === 'mini-story') {
    return studyLanguage === EApiLanguageCode.ENGLISH
      ? EApiAttendanceType.ENGLISH_STORY
      : EApiAttendanceType.JAPANESE_STORY;
  }
  if (subMenu === 'grammar') {
    return studyLanguage === EApiLanguageCode.ENGLISH
      ? EApiAttendanceType.ENGLISH_CLOZE_GRAMMAR
      : EApiAttendanceType.JAPANESE_CLOZE_GRAMMAR;
  }
  if (subMenu === 'listening') {
    return studyLanguage === EApiLanguageCode.ENGLISH
      ? EApiAttendanceType.ENGLISH_CLOZE_LISTENING
      : EApiAttendanceType.JAPANESE_CLOZE_LISTENING;
  }
  if (subMenu === 'vocabulary') {
    return studyLanguage === EApiLanguageCode.ENGLISH
      ? EApiAttendanceType.ENGLISH_CLOZE_VOCABULARY
      : EApiAttendanceType.JAPANESE_CLOZE_VOCABULARY;
  }
  if (subMenu === 'vocabulary-book') {
    return studyLanguage === EApiLanguageCode.ENGLISH
      ? EApiAttendanceType.ENGLISH_VOCABULARY_BOOK
      : EApiAttendanceType.JAPANESE_VOCABULARY_BOOK;
  }
  return EApiAttendanceType.OPEN;
};
